import { sireSubTabs } from './tabNames';

const calculateTabUrl = (currentTab, tabName, index, isSire, isMyRatingShown) => {
    // when current tab is missing (we are on the index tab)
    // tab with index = 0 would be active
    if (!currentTab && !index) { return ''; }
    if ((tabName === 'form') && isMyRatingShown) { return `${tabName}/my-ratings`; }
    if (!isSire) { return tabName; }

    // if we are on sire profiles there are subtabs
    // and sometimes title of tab is different from url
    const subTabs = sireSubTabs[tabName];
    if (subTabs) {
        return subTabs.includes(currentTab) ?
            currentTab : subTabs[0];
    }
    return tabName;
};

export default calculateTabUrl;



// WEBPACK FOOTER //
// ./src/js/shared/nav/helpers/calculateTabUrl.js